import { render, staticRenderFns } from "./ModalDesligamento.vue?vue&type=template&id=ce12b29a"
import script from "./ModalDesligamento.vue?vue&type=script&lang=js"
export * from "./ModalDesligamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports